/**
 * BoxWithBorderComponent
 * @returns <BoxWithBorder />
 */

import { formatPrice } from "../scripts/helpers/formatPrice"

const BoxWithBorder = ({ type, label, currency, price, subtotalLabel, subtotal, discount }) => {
    // It could be more types
    if (type === "price") {
        return (
            <div className="box-with-border">
                <p className="box-with-border__label">{label}</p>

                <p className="box-with-border__price">
                    <strong>{price && `${currency === " USD" ? "U$D" : "$"} ${formatPrice(price)}`}</strong>
                </p>
            </div>
        )
    }

    if (type === "cart-totals") {
        return (
            <div className="box-with-border --cart-totals">
                {/* {items.map((item, i) => {
                    return (
                    )
                })} */}

                <div className="box-with-border__container item">
                    <p className="box-with-border__label">{label}</p>

                    <p className="box-with-border__price">
                        {price && `${currency === " USD" ? "U$D" : "$"} ${formatPrice(price)}`}
                    </p>
                </div>

                {discount && (
                    <div className="box-with-border__container item">
                        <p className="box-with-border__label">{`Descuento ${discount.percentage}%`}</p>

                        <p className="box-with-border__price">
                            {`- ${discount.currency === " USD" ? "U$D" : "$"} ${formatPrice(discount.price)}`}
                        </p>
                    </div>
                )}

                <div className="line"></div>

                <div className="box-with-border__container subtotal">
                    <p className="box-with-border__label"><strong>Subtotal</strong></p>

                    <p className="box-with-border__price">
                        <strong>{`${currency === " USD" ? "U$D" : "$"} ${formatPrice(discount ? price - discount.price : price)}`}</strong>
                    </p>
                </div>
            </div>
        )
    }
}

export default BoxWithBorder